import React from 'react';
import useAuthGateState from './useAuthGateState';

// ECDEX-3441 (MR E): the thunks that call the BFF with the candidate JWT
// (submitDispute, submitCandidateStories) take it as an argument instead of
// reading it from Redux. These forms are class components wrapped in
// connect/reduxForm, so this adapter reads it with the hook and passes it
// down as `candidateJwt`, which the form passes to the thunk on submit. Same
// shape as the WithBreakpoint adapter.
export const withCandidateJwt = <P extends object>(
  Component: React.ComponentType<P & { candidateJwt?: string | null }>,
) => {
  const WithCandidateJwt: React.FC<P> = props => {
    const { candidateLogin } = useAuthGateState();
    return <Component {...props} candidateJwt={candidateLogin.candidateJwt} />;
  };
  WithCandidateJwt.displayName = `withCandidateJwt(${
    Component.displayName || Component.name || 'Component'
  })`;
  return WithCandidateJwt;
};
